import View from "../../../Account/Js/views/OrderView";
import components from "./components.js";
components.define("js-Order", View);